<template>
  <div class="form">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="在线验货"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="form-body">
      <!-- 上传个人信息 -->
      <section class="upload-area">
        <div class="title">上传个人信息</div>
        <div class="detail">{{uploadTitle}}</div>
        <div class="area">
            <div class="title">
              <span>1</span>
              <span>拍摄上传本人（{{name}}）手持身份证照片</span>
            </div>
            <div class="detail">请确保本人脸露出无遮挡，便于审核识别</div>
            <div class="upload">
              <div class="sample-cover" :style="{backgroundImage: `url(${imgs[0]})`}"></div>
              <media-upload-item class="id-card"
                             order="1"
                             type="front"
                             @uploaded="Uploaded">
            <div class="cover">
              <div class="add"></div>
              <span>点击拍摄</span>
            </div>
          </media-upload-item>
            </div>
            <div class="uploadbottom">
              <span>示例</span>
              <span>上传合照</span>
            </div>
        </div>
        <div class="area">
          <div class="title">
            <span>2</span>
            <span>拍摄上传已售出凭证</span>
          </div>
          <div class="detail">拍摄上传已售出凭证、交易截图等；凭证中最好能提现出为当前商品交易，方便后期定位（最多上传6张）</div>
          <z-upload
            v-model="pics"
            ref="upload"
            :process-file="processFile"
            accept="image/*"
            :max="6"
          >
          <div class="custom-upload">
            <z-upload-file
              v-for="(file, index) in pics"
              :file="file"
              :key="index"
            />
            <z-upload-btn>
              <div class="icon"></div>
              <span>点击拍摄/上传</span>
            </z-upload-btn>
          </div>
          </z-upload>
        </div>
      </section>
      <section class="description">
          <div class="title">事件描述</div>
          <div class="item">
            <z-field
              ref="textArea"
              @blur="txtBoxBlur"
              v-model="desc"
              type="textarea"
              placeholder="请描述您遇到的问题，可帮助平台准确处理"
              rows="3"
              autosize
              :maxlength="500"
              count-word
            />
          </div>
        </section>
    </div>
    <!-- 下一步 -->
      <z-button-group keep-position class="bottom-button">
        <z-button size="small-detail" :disabled="!isSubmited" type="primary" @click="submit">提交审核</z-button>
      </z-button-group>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import { FixTop, NavBar, Upload, Button, ButtonGroup, Field, Dialog } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import { lego } from '@zz-common/lego'
import { submitcloudcheck } from '@api/resourceApi'
//  TODO
import compress from '@zz-common/zz-ui/lib/utils/image'
import MediaUploadItem from './MediaUploadItem/MediaUploadItem'
import { toast } from '../../native'
import { queryParams, tranPics, getCookie } from '../../lib/utils'
const query = queryParams()

export default {
  name: 'UnableInspect',
  data() {
    return {
      native,
      id: query.id || this.$route.query.id,
      name: query.name || this.$route.query.name,
      infoId: query.infoId || this.$route.query.infoId,
      radioId: '',
      uploadTitle: '您提供的信息仅用于信息核查，转转保证您的信息安全不被泄露',
      desc: '',
      getCamera: '',
      pics: [],
      oneSubmit: true,
      imgs: [require('./images/heldidcard.jpg')]
    }
  },
  components: {
    MediaUploadItem,
    zUpload: Upload,
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-button-group': ButtonGroup,
    'z-field': Field,
    zUploadBtn: Upload.Btn,
    zUploadFile: Upload.File
  },
  computed: {
    isSubmited() {
      return this.pics.every((item) => item.url !== '') &&
            this.pics.length > 0 &&
            this.getCamera !== '' && this.desc.length
    }
  },
  methods: {
    setPicSize,
    closePage() {
      native.close()
    },
    txtBoxBlur() {
      setTimeout(() => {
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
    },
    Uploaded(rst, _startTime, _order) {
      this.getCamera = rst
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    },
    submit() {
      const params = {
        id: this.id,
        infoId: this.infoId,
        reason: this.desc
      }
      if (this.getCamera === '') {
        return toast({ msg: '请拍摄本人身份证照片后再提交', style: '2' })
      }
      if (this.pics.length < 1 && this.pics.every((item) => item.url !== '')) {
        return toast({ msg: '请至少上传一张凭证', style: '2' })
      }
      if (this.pics.length > 6) return toast({ msg: '您至多上传六张凭证', style: '2' })
      if (!this.isSubmited) return ''
      if (!this.oneSubmit) return ''
      this.oneSubmit = false
      const picUrls = tranPics(this.pics)
      return this.submitCloudCheck({
        ...params,
        checkType: '1',
        evidence: [this.getCamera, ...picUrls].join('|')
      })
    },
    submitCloudCheck(params) {
      return submitcloudcheck(params)
        .then((res) => {
          const { code = '', msg = '' } = res
          lego.send({
            pagetype: 'ZZUP_CLOUDUNINSPECTION',
            actiontype: 'CLICK_SUCCESS',
            backup: {
              code,
              msg,
              radioId: this.radioId,
              uid: getCookie('uid'),
              ...params
            }
          })
          if (code !== '0') {
            this.oneSubmit = true
            return toast({ msg, style: '2' })
          }
          Dialog({
            title: '提交成功',
            message: '您的在线验货信息已提交成功，系统将在24小时内反馈审核结果，请耐心等待',
            closeOnClickOverlay: false
          }).then(() => {
            native.close()
          });
        })
        .catch((err) => {
          this.oneSubmit = true
          lego.send({
            pagetype: 'ZZUP_CLOUDUNINSPECTION',
            actiontype: 'CLICK_FAIL',
            backup: {
              radioId: this.radioId,
              uid: getCookie('uid'),
              ...params
            }
          })
          toast({
            msg: err.message || '提交失败',
            style: '2'
          })
          console.error(err)
        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'UnableInspect.less';
</style>
